import { render } from "./PageNotFound.vue?vue&type=template&id=1f0bddf0"
import script from "./PageNotFound.vue?vue&type=script&lang=js"
export * from "./PageNotFound.vue?vue&type=script&lang=js"
script.render = render

export default script